import React from "react";
import styles from "./Button.module.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  color?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  color,
  ...props
}) => {
  return (
    <button
      className={`${styles.button} ${
        color ? styles[`button-${color}-color`] : ""
      }`}
      {...props}
    >
      {children}
    </button>
  );
};
